<template>
  <div>
    <t-loader :loading="isBusy"></t-loader>
    <div class="row">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div>
                Streamlabs Api Call Records
                <br>
                <small>A history of calls to the Streamlabs API</small>
              </div>
            </div>
            <div class="card-body">
              <b-table
                  show-empty
                  :responsive="true"
                  :items="myProvider"
                  :busy.sync="isBusy"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  ref="table">
                <template v-slot:cell(donation_ids)="data">
                  <div class="d-flex justify-content-center align-items-center flex-column">
                    <b-collapse :id="'collapse-'+data.item.id" class="mb-2" style="max-width: 32rem">
                        {{ data.item.donation_ids }}
                    </b-collapse>
                    <b-button v-b-toggle="'collapse-'+data.item.id" class="showAllButton text-info" toggle-class="text-decoration-none" variant="link">
                      <span class="when-open">Hide</span>
                      <span class="when-closed">Show all</span>
                    </b-button>
                  </div>
                </template>
                <template v-slot:cell(verified)="data">
                  {{ data.item.verified ? 'True' : 'False' }}
                </template>
                <template v-slot:cell(created_at)="data">
                  {{ formatDateTime(data.item.created_at) }}
                </template>
              </b-table>
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'StreamlabsApiRecordTable',
  props: {},
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      transactions: [],
      isBusy: false,
      search: '',
      defaultFields: [
        {key: 'id', label: '#'},
        {key: 'user', label: 'User ID'},
        {key: 'before', label: 'Before'},
        {key: 'after', label: 'After'},
        {key: 'from_donation_id', label: 'From'},
        {key: 'to_donation_id', label: 'To'},
        {key: 'donation_ids', label: 'Donation IDs'},
        {key: 'count', label: 'Donations found'},
        {key: 'limit_per_call', label: 'Limit per call'},
        {key: 'number_of_calls', label: 'Number of calls'},
        {key: 'verified', label: 'Verified'},
        {key: 'created_at', label: 'Called at'},
      ],
    };
  },
  computed: {
    fields() {
      return this.defaultFields;
    },
  },
  methods: {
    timeSinceTimestamp(ts) {
      return moment(ts).fromNow();
    },
    formatDateTime(ts) {
      return moment(ts).format('YYYY-MM-DD HH:mm');
    },
    myProvider(ctx) {
      let path = `/admin/services/streamlabs/api/records`;

      const query = `?page=${ctx.currentPage}&size=${ctx.perPage}`;
      const url = path + query;
      let promise = axios.get(url);

      return promise.then((response) => {
        const root = response.data;
        const data = root.data;
        const meta = root.meta;

        this.currentPage = meta.current_page;
        this.totalRows = meta.total;
        this.transactions = data || [];

        return this.transactions;
      }).catch(error => {
        return [];
      });
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.refresh();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.showAllButton {
  font-size: x-small;
  padding: 0;
}
.collapsed > .when-open,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
